module.exports = __webpack_public_path__ + "static/images/driver.2XRlJjA.svg";